<template>
  <v-row>
    <v-col cols="12">
      <add-subdomain-form @subdomain-added="reloadTable"></add-subdomain-form>
    </v-col>
    <v-col cols="12">
          <subdomains-table :table-should-be-reloaded="tableShouldBeReloaded"
                            @table-reloaded="tableReloaded"
          />
    </v-col>
  </v-row>
</template>

<script>
import AddSubdomainForm from '@/components/Services/Hosting/Shared/Domains/SubDomains/AddSubdomainForm'
import SubdomainsTable from '@/components/Services/Hosting/Shared/Domains/SubDomains/SubdomainsTable'

export default {
  name: 'SubdomainsView',
  components: {
    AddSubdomainForm,
    SubdomainsTable,
  },
  data () {
    return {
      tableShouldBeReloaded: false,
    }
  },
  methods: {
    reloadTable () {
      this.tableShouldBeReloaded = true
    },
    tableReloaded () {
      this.tableShouldBeReloaded = false
    },
  },
}
</script>
